{
  "title": "الحركات المعلقة",
  "mode": {
    "title": "وضع الجرد",
    "on": "مفعل",
    "off": "غير مفعل",
    "since": "منذ {{time}} بواسطة {{name}}",
    "turnOn": "تفعيل وضع الجرد",
    "turnOff": "إيقاف وضع الجرد",
    "confirmOn": "تفعيل وضع الجرد على {{product}}؟",
    "confirmOff": "إيقاف وضع الجرد على {{product}}؟",
    "confirmDescription": "يسجل التغيير باسمك وبوقته في سجل التدقيق.",
    "loadFailed": "تعذر تحميل حالة وضع الجرد"
  },
  "toolbar": {
    "searchLabel": "الرقم",
    "searchPlaceholder": "بحث بالرقم...",
    "postingStatus": "حالة الترحيل",
    "allStatuses": "الكل",
    "type": "النوع",
    "allTypes": "جميع الأنواع",
    "product": "المادة",
    "allProducts": "جميع المواد"
  },
  "type": {
    "PURCHASE": "الشراء",
    "SALE": "البيع النقدي",
    "DEBT_SALE": "بيع الذمم",
    "PAYMENT": "المدفوعات",
    "RECEIPT": "المقبوضات"
  },
  "columns": {
    "number": "الرقم",
    "type": "النوع",
    "product": "المادة",
    "customer": "العميل",
    "barrels": "إجمالي البراميل",
    "jerrycans": "إجمالي الجراكل",
    "finalTotal": "الإجمالي النهائي",
    "completionStatus": "حالة الإكمال",
    "entryTime": "وقت الإدخال",
    "employee": "الموظف",
    "completionEmployee": "موظف الإكمال",
    "postingStatus": "حالة الترحيل",
    "postingTime": "وقت الترحيل",
    "postedBy": "رحلها",
    "businessDate": "تاريخ العمل"
  },
  "completion": {
    "COMPLETED": "مكتملة",
    "AWAITING_PRICE": "بانتظار التسعير"
  },
  "posting": {
    "PENDING": "معلقة",
    "POSTED": "مرحلة"
  },
  "actions": {
    "view": "عرض",
    "completePrice": "إكمال السعر",
    "post": "ترحيل"
  },
  "postConfirm": {
    "title": "ترحيل الحركة {{reference}}؟",
    "number": "رقم الحركة",
    "entryTime": "وقت الإدخال",
    "businessDate": "تاريخ العمل الذي سترحل إليه",
    "loading": "جاري التحميل...",
    "modeActive": "وضع الجرد مفعل: ستضاف الحركة إلى الشفت الذي يجري جرده الآن.",
    "forceConfirm": "أؤكد إجبار ترحيل الحركة إلى الشفت الذي يجري جرده",
    "force": "إجبار الترحيل"
  },
  "toast": {
    "posted": "تم ترحيل الحركة إلى تاريخ العمل {{date}}"
  },
  "empty": {
    "noData": "لا توجد حركات معلقة",
    "noResults": "لا توجد نتائج"
  },
  "forced": "ترحيل إجباري",
  "bulk": {
    "action": "ترحيل المحدد",
    "selectAll": "تحديد الكل",
    "selectRow": "تحديد الحركة {{reference}}",
    "selectedLabel": "المحدد: {{count}}",
    "selectHint": "حدد حركة معلقة واحدة على الأقل لترحيلها.",
    "title": "ترحيل الحركات المحددة",
    "selectedCount": "الحركات المحددة",
    "eligibleCount": "الجاهزة للترحيل",
    "groupDate": "سترحل إلى تاريخ العمل",
    "groupCount": "العدد: {{count}}",
    "refusedTitle": "لن ترحل هذه الحركات وتبقى معلقة:",
    "noneEligible": "لا توجد بين المحدد حركة جاهزة للترحيل.",
    "modeActive": "وضع الجرد مفعل: ستضاف الحركات إلى الشفت الذي يجري جرده الآن.",
    "forceConfirm": "أؤكد إجبار ترحيل الحركات إلى الشفت الذي يجري جرده",
    "resultTitle": "نتيجة الترحيل",
    "postedCount": "تم ترحيلها",
    "failedCount": "تعذر ترحيلها",
    "failedTitle": "بقيت هذه الحركات معلقة:",
    "toastPosted": "تم ترحيل الحركات المحددة: {{count}}"
  }
}
